import { gql } from '@apollo/client';

export const GET_MESSAGES = gql`
  query GetMessages($conversationId: ID!) {
    getMessages(conversationId: $conversationId) {
      _id
      senderId
      receiverId
      conversationId
      content
      createdAt
      isRead
    }
  }
`;